import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

const faqs = [
  {
    id: 1,
    question: "What is the difference between Tier 1 and Tier 2 Account?",
    answer:
      "Both NPS Tier 1 and Tier 2 accounts have their set of advantages and considerations. While Tier 1 offers significant tax benefits and is primarily designed for long-term retirement savings, Tier 2 investments provide more withdrawal flexibility and can cater to immediate financial needs.",
  },
  {
    id: 2,
    question: "What are the Documents required to open NPS?",
    answer:
      "You will need basic KYC documents such as Aadhaar, PAN card, address proof, and a passport-size photograph. For online registration, digital copies are sufficient.",
  },
  {
    id: 3,
    question: "What are the Different Schemes for Investment?",
    answer:
      "NPS offers Auto Choice (Lifecycle Fund) and Active Choice options, allowing investments across asset classes like equity, corporate bonds, government securities, and alternative assets.",
  },
];

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(1);

  const toggleFAQ = (id: number) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  return (
    <section className="mx-auto my-4 w-full px-5 sm:p-8 md:my-12 md:max-w-[70%] md:px-0 lg:my-20 lg:rounded-[20px] lg:p-10">
      <div className="flex w-full flex-col items-center justify-start gap-2 md:gap-8">
        {/* Title */}
        <h2 className="text-center font-sans text-2xl font-bold leading-tight text-[#1D2C56] sm:text-4xl lg:text-5xl">
          FAQ
        </h2>

        {/* FAQ List */}
        <div className="mb-5 w-full sm:mb-0">
          {faqs.map(faq => (
            <div
              key={faq.id}
              className="border-b-[3px] border-b-[#F5F5F5] py-4 sm:py-5"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="flex w-full items-center justify-between gap-2 text-left focus:outline-none"
              >
                <span className="font-sans text-[16px] font-semibold text-[#2F363F] md:text-[20px]">
                  {faq.id}. {faq.question}
                </span>
                <div
                  className={`flex h-10 w-8 items-center justify-center rounded-[10px] text-[#707070] sm:h-10 sm:w-10 sm:rounded-full ${
                    openFAQ === faq.id
                      ? "bg-[#1D2C56] text-[#fff]"
                      : "bg-[#F5F5F5] text-[#707070]"
                  }`}
                >
                  {openFAQ === faq.id ? (
                    <ChevronDown className="h-6 w-6" />
                  ) : (
                    <ChevronRight className="h-6 w-6" />
                  )}
                </div>
              </button>

              <div
                className={cn(
                  "overflow-hidden transition-all duration-300 ease-in-out",
                  openFAQ === faq.id
                    ? "mt-3 max-h-40 opacity-100"
                    : "max-h-0 opacity-0"
                )}
              >
                <p className="ml-0 font-sans text-[16px] leading-relaxed text-[#3C3C43D9] sm:ml-8 md:ml-6 md:text-[20px]">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
